import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { Typography } from '@klp/design';
import { NumberFormatted } from '@klp/formgenerator/components/NumberFormatted';
import { ProsjektAvfallSortert } from './ProsjektAvfallSortert';
import type { Avfall } from '@klp/environment/services/rtkApi';

const useStyles = makeStyles(() => ({
    numberCell: {
        textAlign: 'right',
    },
}));

type ProsjektAvfallDisplayRowProps = {
    avfall: Avfall;
    totalMengde: number;
};

export function ProsjektAvfallDisplayRow({
    avfall,
    totalMengde,
}: ProsjektAvfallDisplayRowProps) {
    const classes = useStyles();
    const kg = ' kg';

    const avfallTypeText =
        avfall.avfallTypeId !== null
            ? `${avfall.avfallTypeId} - ${avfall.avfallType}`
            : avfall.avfallType;

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={2}>
                <ProsjektAvfallSortert sortert={avfall.sortert} />
            </Grid>
            <Grid item={true} xs={6}>
                <Typography>{avfallTypeText}</Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography>
                    <NumberFormatted value={avfall.mengde} suffix={kg} />
                </Typography>
            </Grid>
            <Grid item={true} xs={2} className={classes.numberCell}>
                <Typography>
                    <NumberFormatted
                        value={(avfall.mengde / totalMengde) * 100}
                        decimalScale={1}
                        suffix=" %"
                    />
                </Typography>
            </Grid>
        </Grid>
    );
}
